import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-inflationcurvechart';

class InflationCurveChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height)
      .on('selected', this.props.onSelected)
      .vol(this.props.vol)
      .infAdj(this.props.infAdj);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height)
      .vol(this.props.vol)
      .infAdj(this.props.infAdj);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart);
  }

  render() {
      return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(InflationCurveChart);


// WEBPACK FOOTER //
// ./src/charts/InflationCurveChart.js